import { Button } from '#atoms';
import { PATH } from '#const/path';
import usePatchCurrentStepMutation from '#hooks/queries/onboard/usePatchCurrentStepMutation';
import { FloatButtonContainer } from '#molecules';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { useNavigate } from 'react-router';
import { useOnBoardStep } from '../OnBoardStep/OnBoardStep.hooks';
import LoadModal from './components/LoadModal';
import * as S from './styles';

export function OnBoardIntro() {
  const navigate = useNavigate();
  const { setStep } = useOnBoardStep();
  const { mutateAsync: patchCurrentStep } = usePatchCurrentStepMutation();
  const handleNext = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'onboarding_profile_click',
        category: '신규가입 온보딩',
        action: 'onboarding_profile_click',
        value: 2
      }
    });
    navigate(PATH.ONBOARD_STEP);
    patchCurrentStep(1);
  };
  useEffect(() => {
    setStep(1);
  }, []);
  return (
    <PrevHeaderBarWithTitleTemplate title="">
      <S.Wrapper>
        <S.Title>
          <S.Strong>피벗</S.Strong>과 함께{'\n'}나를 브랜딩하고,{'\n'}
          <S.Strong>신규 및 재등록 매출</S.Strong>을{'\n'}올려보세요.
        </S.Title>

        <S.SubTitle>
          브랜딩을 시작하기 위해{'\n'}몇가지 정보가 필요해요.
        </S.SubTitle>
        <LoadModal />
      </S.Wrapper>

      <FloatButtonContainer>
        <Button onClick={handleNext}>시작하기</Button>
      </FloatButtonContainer>
    </PrevHeaderBarWithTitleTemplate>
  );
}
